/* PawMoM storefront behaviour — vanilla, no dependencies. */
(function () {
  'use strict';

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nav-open]');
    var close = e.target.closest('[data-nav-close]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!drawer) return;
    if (open) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (close) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-gallery]');
    var main = root && root.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.dataset.full;
    main.srcset = '';
    root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- variant picker ---------- */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-variant-price]');
    var btn = form.querySelector('[data-add-button]');
    var money = form.dataset.moneyFormat || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, value)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                  .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    }

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var active = group.querySelector('.opt__value.is-active');
        return active ? active.dataset.value : null;
      });
    }

    function update() {
      var chosen = selected();
      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];

      if (!match) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = form.dataset.unavailableText || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '<span class="' + (match.compare_at_price > match.price ? 'is-sale' : '') + '">' + formatMoney(match.price) + '</span>';
        if (match.compare_at_price > match.price) html += '<s>' + formatMoney(match.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
      }
      if (btn) {
        if (match.available) {
          btn.removeAttribute('aria-disabled');
          btn.textContent = form.dataset.addText || 'Add to cart';
        } else {
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = form.dataset.soldOutText || 'Sold out';
        }
      }
      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('click', function (e) {
      var val = e.target.closest('.opt__value');
      if (!val) return;
      e.preventDefault();
      var group = val.closest('[data-option-index]');
      group.querySelectorAll('.opt__value').forEach(function (v) { v.classList.remove('is-active'); });
      val.classList.add('is-active');
      update();
    });

    update();
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(parseInt(input.min || 1, 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart line quantity ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
